import script from "./SlideProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./SlideProfile.vue?vue&type=script&lang=ts&setup=true"

import "./SlideProfile.vue?vue&type=style&index=0&id=3b263308&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b263308"]])

export default __exports__